import {
    MenuBook,
    Dashboard as DashboardIcon,
    Description as FileIcon,
    People as ClientsIcon,
    Storefront as GoodsIcon,
    Inventory2 as InventoryShopIcon,
    AccountBalanceWallet as CashIcon,
    FactCheck as VerifyIcon,
    Payments as DispoIcon,
    Diamond as MetalIcon,
    SwapHoriz as MovementIcon,
    MonitorHeart as ControlIcon,
    Assessment as StatsIcon,
    BarChart as ReportsIcon,
    Summarize as RapoarteIcon,
    AccountBalance as AccountingIcon,
    Undo as StornoIcon,
    Print as ListingsIcon,
    ListAlt as RegistruIcon,
    Groups as SalaryIcon,
    Build as AdvancedIcon,
    Tune as ConfigIcon,
    Settings as SettingsIcon,
    NewReleases as ChangelogIcon,
    SwitchAccount as ChangeUserIcon,
} from '@mui/icons-material';

const iconMap: Record<string, React.ReactNode> = {
    overview: <MenuBook />,
    dashboard: <DashboardIcon />,
    contracts: <FileIcon />,
    clients: <ClientsIcon />,
    'goods-sale': <GoodsIcon />,
    'inventory-shop': <InventoryShopIcon />,
    pred_casa: <CashIcon />,
    frmverifylastsession: <VerifyIcon />,
    dispozitii: <DispoIcon />,
    schutil: <ChangeUserIcon />,
    metals: <MetalIcon />,
    'inventory-movement': <MovementIcon />,
    'control-room': <ControlIcon />,
    statistics: <StatsIcon />,
    reports: <ReportsIcon />,
    rapoarte: <RapoarteIcon />,
    contabilitate: <AccountingIcon />,
    frmstorno: <StornoIcon />,
    frmlistari: <ListingsIcon />,
    regiszter: <RegistruIcon />,
    salary: <SalaryIcon />,
    advanced: <AdvancedIcon />,
    configuration: <ConfigIcon />,
    settings: <SettingsIcon />,
    changelog: <ChangelogIcon />,
};

/** Resolve a help topic icon key to an icon, defaulting to the manual icon. */
export const getTopicIcon = (iconKey: string): React.ReactNode =>
    iconMap[iconKey] ?? <MenuBook />;
